import * as React from 'react';

interface Props {
  color?: string;
  size?: number;
  className?: string;
}

const EuropeStars: React.FC<React.PropsWithChildren<Props>> = ({
  color = 'yellow',
  size = 30,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 300"
      width={size}
      height={size}
      className={className}
    >
      <g id="prefix__c" transform="translate(150 30)" fill={color}>
        <g id="prefix__b">
          <path id="prefix__a" d="M0-20V0h10" transform="rotate(18 0 -20)" />
          <use xlinkHref="#prefix__a" transform="scale(-1 1)" />
        </g>
        <use xlinkHref="#prefix__b" transform="rotate(72)" />
        <use xlinkHref="#prefix__b" transform="rotate(144)" />
        <use xlinkHref="#prefix__b" transform="rotate(216)" />
        <use xlinkHref="#prefix__b" transform="rotate(288)" />
      </g>
      <use xlinkHref="#prefix__c" transform="translate(60 16.077)" />
      <use xlinkHref="#prefix__c" transform="translate(103.923 60)" />
      <use xlinkHref="#prefix__c" transform="translate(120 120)" />
      <use xlinkHref="#prefix__c" transform="translate(103.923 180)" />
      <use xlinkHref="#prefix__c" transform="translate(60 223.923)" />
      <use xlinkHref="#prefix__c" transform="translate(0 240)" />
      <use xlinkHref="#prefix__c" transform="translate(-60 223.923)" />
      <use xlinkHref="#prefix__c" transform="translate(-103.923 180)" />
      <use xlinkHref="#prefix__c" transform="translate(-120 120)" />
      <use xlinkHref="#prefix__c" transform="translate(-103.923 60)" />
      <use xlinkHref="#prefix__c" transform="translate(-60 16.077)" />
    </svg>
  );
};

export default EuropeStars;
